<template>
  <div
    class="toast"
    :class="{'icon-toast':icon}"
    v-if="!hide"
    :style="{ opacity: opacity,visibility: opacity===0?'hidden':'visible' }"
  >
    <div v-if="icon === 'success'" class="icon"></div>
    <div class="toast-inner">{{innerText}}</div>
  </div>
</template>
<script>
export default {
  name: "showTips",
  data() {
    return {
      opacity: 0,
      hide: false,
      innerText: "",
      icon: null
    };
  },

  methods: {
    showTips(tips, time = 2000, icon) {
      this.hide = false;
      this.innerText = tips;
      if (icon) {
        this.icon = icon;
      }
      this.$nextTick(() => {
        this.opacity = 1;
        if (this.hideTimeout) {
          clearTimeout(this.hideTimeout);
        }
        this.hideTimeout = setTimeout(() => {
          this.hideTips();
        }, time);
      });
    },
    hideTips() {
      clearTimeout(this.hideTimeout);
      this.hide = true;
    }
  },

  mounted() {
    // setTimeout(() => {
    //   this.opacity = 1;
    // }, 1000);
  }
};
</script>
<style lang="scss" scoped>
.toast {
  position: fixed;
  z-index: 9999;
  left: 50%;
  top: 50%;
  transition: all 0.5s ease-in-out;
  transform: translate(-50%, -50%);
  background: rgba(34, 34, 34, 0.8);
  opacity: 0;
  border-radius: 8px;
  overflow: hidden;
}
.icon-toast {
  border-radius: 20px;
}
.icon {
  margin: 0 auto;
  margin-top: 44px;
  width: 93px;
  height: 86px;
  background: url(https://azure-shop.obs.cn-south-1.myhuaweicloud.com/20201207135323883-icon_toast_success%403x.png)
    no-repeat center center/ contain;
}
.toast-inner {
  color: #fff;
  text-align: center;
  padding: 31px 40px;
  min-width: 234px;
  font-size: 28px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  line-height: 34px;
  max-width: 700px;
  white-space: nowrap;
}
</style>
